/* DOC reference https://momentjs.com/docs/#/displaying/difference/ */
export const DATE_TIME = {
  YEARS: 'years',
  MONTHS: 'months',
  WEEKS: 'weeks',
  DAYS: 'days',
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
};

export const USER_TYPE = {
  EDITOR: 'Editor',
  GUEST: 'Guest',
};

export const ONBOARDING_STATUS = {
  TO_DO: {
    key: 'TO_DO',
    value: 'Não iniciado',
  },
  DOING: {
    key: 'DOING',
    value: 'Em andamento',
  },
  DONE: {
    key: 'DONE',
    value: 'Finalizado',
  },
  SKIP: {
    key: 'SKIP',
    value: 'Não realizado',
  },
};

export const EDITOR_TYPE = {
  FIRST: 'Primeiro',
  SECOND: 'Segundo',
};

export const EXTENSION_TYPES = {
  PNG: {
    name: 'PNG',
    mimeType: 'image/png',
  },
  PDF: {
    name: 'PDF',
    mimeType: 'application/pdf',
  },
  SVG: {
    name: 'SVG',
    mimeType: 'image/svg+xml',
  },
  CSV: {
    name: 'CSV',
  },
};

export const STATUS = {
  OPEN: 'Aberto',
  CLOSE: 'Fechado',
  PENDING: 'Pendente',
  ON_HOLD: 'Em Espera',
  ANSWERED: 'Respondido',
  IGNORED: 'Ignorado',
};

export const SAC_STATUS = {
  OPEN: 'posted_to_open',
  WAITING: 'waiting',
  ANSWER: 'open_to_answer',
  FINISHED: 'answer_to_finished',
};

export const CHANNELS = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  youtube: 'YouTube',
  twitter: 'Twitter',
  tumblr: 'Tumblr',
  comentariosemartigos: 'Comentários em Artigos',
  blogs: 'Blogs',
  foruns: 'Fóruns',
  googleplay: 'Google Play',
  googleplus: 'Google Plus',
  googlemybusiness: 'Google Meu Negócio',
  foursquare: 'Foursquare',
  buscape: 'Avaliações de Produtos',
  reclameaqui: 'Reclame Aqui',
  linkedin: 'LinkedIn',
  site: 'Site',
  tv: 'TV',
  zapier: 'Zapier',
  news: 'Portais',
  notClassified: 'Não Classificado',
  facebookgroups: 'Grupos no Facebook',
  facebookcomments: 'Comentários no Facebook',
  instagramcomments: 'Comentários no Instagram',
  youtubecomments: 'Comentários no YouTube',
  linkedincomments: 'Comentários no LinkedIn',
  twitterinbox: 'Inbox do Twitter',
  facebookinbox: 'Inbox do Facebook',
  portais: 'Portais',
  rádio: 'Rádio',
  boxnetradio: 'Rádio',
  impressas: 'Impresso',
  boxnetprintednews: 'Impresso',
  blip: 'Blip',
  ImportedData: 'Dados Importados',
  bluesky: 'Bluesky',
};

export const DOMAINS = {
  '0mn.io': 'BLiP Chat',
  'messenger.gw.msging.net': 'Messenger',
  'workplace.gw.msging.net': 'Workplace',
  'telegram.gw.msging.net': 'Telegram',
  'mailgun.gw.msging.net': 'E-mail',
  'instagram.gw.msging.net': 'Instagram',
  'googlercs.gw.msging.net': 'Google RCS',
  'pagseguro.gw.msging.net': 'PagSeguro',
  'wa.gw.msging.net': 'Whatsapp',
  'assistant.gw.msging.net': 'Google Assistent',
  'abs.gw.msging.net': 'Azure Bot Service',
  'businesschat.gw.msging.net': 'Apple Messages for Business',
  'alexa.gw.msging.net': 'Amazon Alexa',
  'businessmessages.gw.msging.net': 'Google Business Messages',
};

export const DEPARTMENT_LIST = [
  'Administrativo',
  'Assessoria de Imprensa',
  'Atendimento',
  'Branding',
  'Business Intelligence - BI',
  'Câmara dos Deputados',
  'Comercial',
  'Community Center',
  'Community Management',
  'Comunicação',
  'Consumer & Market Insights - CMI',
  'Consumer Care',
  'Conteúdo',
  'Criação',
  'Customer Experience',
  'Customer Journey',
  'Customer Relationship Management - CRM',
  'Customer Success',
  'Data Intelligence',
  'Data Science',
  'Data Strategy',
  'Departamento Pessoal',
  'Design',
  'Digital',
  'Engenharia',
  'Estratégia',
  'Estratégias de Marcas',
  'Estratégias de Mídias',
  'Estratégias Digital',
  'Financeiro',
  'Gestão de marcas',
  'Infraestrutura',
  'Insights',
  'Inteligência',
  'Judiciário',
  'Jurídico',
  'Marketing',
  'Marketing Digital',
  'Mídia',
  'Mídias Sociais',
  'Monitoramento',
  'Negócios',
  'Operações',
  'Performance Digital',
  'Planejamento',
  'Produção Audiovisual',
  'Produto',
  'Projetos',
  'Qualidade',
  'Redação',
  'Redes Sociais',
  'Relacionamento',
  'Relações Públicas',
  'SAC',
  'Segurança da informação',
  'Social Intelligence',
  'Suporte',
  'Tecnologia da Informação - TI',
  'User Experience - UX',
  'Vendas',
];

export const JOB_LIST = [
  'Analista Comercial',
  'Analista de Atendimento',
  'Analista de Banco de Dados',
  'Analista de Business Intelligence - BI',
  'Analista de Clientes',
  'Analista de Comunicação',
  'Analista de Comunicação e Marketing',
  'Analista de CRM',
  'Analista de Customer Success',
  'Analista de Dados',
  'Analista de Data Science',
  'Analista de Informações',
  'Analista de Insights',
  'Analista de Inteligência de Mercado',
  'Analista de Marca',
  'Analista de Marketing',
  'Analista de Marketing e Conteúdo',
  'Analista de Mídia Online',
  'Analista de Mídias',
  'Analista de Mídias Sociais',
  'Analista de MIS',
  'Analista de Monitoramento',
  'Analista de Negócios',
  'Analista de Planejamento',
  'Analista de Planejamento Digital',
  'Analista de Planejamento e Mídia',
  'Analista de Planejamento Estratégico',
  'Analista de Pós-Venda',
  'Analista de Produto',
  'Analista de Qualidade',
  'Analista de Redes Sociais',
  'Analista de Relacionamento',
  'Analista de Relacionamento e Inteligência',
  'Analista de SAC',
  'Analista de SEO',
  'Analista de Suporte',
  'Analista Estatístico',
  'Analista Legislativo',
  'Asistente de Social Mídias',
  'Assessor de Comunicação',
  'Assessor Parlamentar',
  'Assessora de Comunicação',
  'Assessora de Imprensa',
  'Assistente Backoffice',
  'Assistente de Assessoria',
  'Assistente de Atendimento',
  'Assistente de Business Intelligence - BI',
  'Assistente de Cientista de Dados',
  'Assistente de Comunicação',
  'Assistente de Comunicação e Marketing',
  'Assistente de Conteúdo',
  'Assistente de Criação',
  'Assistente de Financeiro',
  'Assistente de Insights',
  'Assistente de Marketing',
  'Assistente de Mídias',
  'Assistente de Mídias Sociais',
  'Assistente de Monitoramento',
  'Assistente de Operações',
  'Assistente de Pesquisa',
  'Assistente de Planejamento',
  'Assistente de Qualidade',
  'Assistente de Redação',
  'Assistente de SAC',
  'Assistente Parlamentar',
  'Assitente de Conta',
  'Associate Executive',
  'Atendente de SAC',
  'Atendimento ao Cliente',
  'Atendimento Digital',
  'Auxiliar de Conteúdo',
  'Backoffice',
  'Broadcast Coordinator',
  'Broadcast Leader',
  'CEO',
  'Cientista de Dados',
  'Community Coordinator',
  'Community Manager',
  'Consultor CRM',
  'Consultor de Comunicação',
  'Consultor de Influenciadores',
  'Consultor de Marketing',
  'Consultor de Negócios',
  'Consultor de Operações',
  'Consultor de Projetos',
  'Consultor de Redes',
  'Consultor de Vendas',
  'Coordenador de Atendimento',
  'Coordenador de Business Intelligence - BI',
  'Coordenador de Comunicação',
  'Coordenador de Conta',
  'Coordenador de Conteúdo',
  'Coordenador de Marketing',
  'Coordenador de Mídia Online',
  'Coordenador de Mídias',
  'Coordenador de Mídias Sociais',
  'Coordenador de Monitoramento',
  'Coordenador de Planejamento',
  'Coordenador de Projetos',
  'Coordenador de Publicidade',
  'Coordenador de Qualidade',
  'Coordenador de Redes Sociais',
  'Coordenador de Relacionamento',
  'Coordenador Geral',
  'Coordenador Operacional',
  'CPO',
  'CTO',
  'Customer Engagement',
  'Customer Engagement Manager',
  'Customer insight',
  'Customer Success Manager',
  'Data Strategy Manager',
  'Data Strategy Manager',
  'Delegado da Polícia Civíl',
  'Desenvolvedor',
  'Desenvolvedor Back-End',
  'Desenvolvedor Front end',
  'Designer',
  'Diretor de Arte',
  'Diretor de Atendimento',
  'Diretor de Business Intelligence - BI',
  'Diretor de Conta',
  'Diretor de Criação',
  'Diretor de Estratégia Digital',
  'Diretor de Influência',
  'Diretor de Insights',
  'Diretor de Marketing',
  'Diretor de Mídias',
  'Diretor de Negócios',
  'Diretor de Novos Negócios',
  'Diretor de Planejamento',
  'Diretor de Tecnologia',
  'Diretor Executivo',
  'Diretor Geral',
  'Editor de Conteúdo',
  'Editor de Texto',
  'Editor de Vídeo',
  'Editor/Redator',
  'Engenheiro de Dados',
  'Estagiário de Business Intelligence - BI',
  'Estagiário de Conteúdo',
  'Estagiário de Insights',
  'Estagiário de Marketing',
  'Estagiário de Métricas',
  'Estagiário de Mídias Sociais',
  'Estagiário de Monitoramento',
  'Estágiário em Assessoria de Comunicação',
  'Estrategista de Conteúdo',
  'Estrategista de Redes Sociais',
  'Executivo de Atendimento',
  'Executivo de Comunicação',
  'Executivo de Conta',
  'Executivo de Inteligência',
  'Executivo de Mídias',
  'Executivo de Novos Negócios',
  'Executivo Digital',
  'Gerente de Atendimento',
  'Gerente de Business Intelligence - BI',
  'Gerente de Comunicação',
  'Gerente de Conta',
  'Gerente de Conteúdo',
  'Gerente de Departamento',
  'Gerente de Estratégia Digital',
  'Gerente de Infraestrutura',
  'Gerente de Insights',
  'Gerente de Inteligência de Dados',
  'Gerente de Marketing',
  'Gerente de Mídias',
  'Gerente de Operações',
  'Gerente de Produção',
  'Gerente de Projetos',
  'Gerente de Relações Públicas',
  'Gestor de Conteúdo',
  'Gestor de Experiência do Cliente',
  'Jovem Aprendiz',
  'Líder CMI',
  'Líder Customer Experience',
  'Líder de Atendimento',
  'Líder de Insights',
  'Líder de Marketing',
  'Líder de Métricas',
  'Líder de Mídia',
  'Líder de Planejamento',
  'Líder de Projetos',
  'Líder Digital',
  'Líder Estratégia e Inovação',
  'Operacional',
  'Pesquisador',
  'Product Manager - PM',
  'Product Marketing Manager - PMM',
  'Product Owner - PO',
  'Produtor de Conteúdo',
  'Professor',
  'Publicitário',
  'Redator',
  'Repórter',
  'Social Media Strategist',
  'Supervisor de Atendimento',
  'Supervisor de Captação',
  'Supervisor de Conta',
  'Supervisor de Monitoramento',
  'Supervisor de Relacionamento',
  'Surpervisor de Planejamento',
  'Tecnologia da Informação - TI',
];

export const USE_CASE_LIST = [
  { text: 'Ajuda na tomada de decisão', type: 'addable' },
  { text: 'Antecipação de crises', type: 'addable' },
  { text: 'Desempenho da marca nos canais proprietários', type: 'addable' },
  { text: 'Gestão dos canais de relacionamento com o consumidor', type: 'addable' },
  { text: 'Gestão de campanhas de marketing e branding', type: 'addable' },
  { text: 'Benchmark de concorrentes', type: 'addable' },
  { text: 'Tendências de mercado e comunidades', type: 'addable' },
];

export const SOCIAL_LISTENING_CASES = ['Monitoramento', 'Descobertas', 'Listening', 'Mar aberto', 'Percepção da marca'];
export const METRICAS_PROPRIETARIAS_CASES = ['Desempenho em canais digitais', 'Alcance da marca', 'Engajamento de fãs', 'Evolução da base de fãs'];
export const SMART_CARE_CASES = ['Atendimento ao consumidor', 'Gestão de atendimento', 'Produtividade', 'Operação de atendimento'];
export const EMPTY_TEMPLATE_CASES = ['Autonomia', 'Personalização', 'Flexibilidade', 'Estrutura específica', 'Especialistas'];
export const UNIVERSE_ID = '5119746434662400';

export const DASHBOARD_MODELS = [
  {
    universeId: UNIVERSE_ID,
    id: 'W9H47bfDULQaQQW3HuAA',
    title: 'Social Listening',
    description: 'Tenha uma visão geral sobre o que está sendo dito em mar aberto, no contexto da sua pesquisa. Monitore canais, publicações, conversas e sentimento da sua audiência nas redes sociais.',
    useCases: SOCIAL_LISTENING_CASES,
    img: require('@/assets/img/studio_social_listening.png'),
  },
  {
    universeId: UNIVERSE_ID,
    id: 'DvF8u7eCrnrkkOgxZkZ5',
    title: 'Métricas Proprietárias',
    description: 'Acompanhe os indicadores das suas páginas proprietárias. Você pode ter uma visão geral de desempenho de todas as suas páginas, como publicações, interações, alcance, impressões e outros. E também pode ter visões focadas em sua base de fãs, engajamento e interações realizadas.',
    useCases: METRICAS_PROPRIETARIAS_CASES,
    img: require('@/assets/img/studio_metricas_proprietarias.png'),
  },
  {
    universeId: UNIVERSE_ID,
    id: '5T3Vl16gMZxjCD0MtboY',
    title: 'Smart Care',
    description: 'Acompanhe sua operação de atendimento em canais digitais. Tenha uma visão geral de toda a operação, além de visões focadas em canais, páginas, operadores e conteúdo das conversas.',
    useCases: SMART_CARE_CASES,
    img: require('@/assets/img/studio_smart_care.png'),
  },
  {
    universeId: UNIVERSE_ID,
    id: '0TuRJDKoK0GOgNNpVilR',
    title: 'Em branco',
    description: 'Para pessoas que já estão acostumadas a usar produtos de visualização de dados. Monte seu dashboard com a narrativa e componentes que mais se adequam à sua visão e objetivo.',
    useCases: EMPTY_TEMPLATE_CASES,
    img: require('@/assets/img/studio_blank_dashboard.png'),
  },
];

export const ERROR_MAP = [
  'emptyData',
  'emptyBot',
  'supportsOnlyOneBot',
];

export const PROJECTION_OPTIONS = {
  teamPerformance: 'stilingue_array.call_id,smartcare_update_date,st_updated_at,pid,channel,uid,sac_type,page_id,root_id,features,is_root,belongs_to_sac_call,posted_at,status,normalized_posted_at, normalized_last_reply',
  importHistory: 'pid,username,posted_at,post_url,processed_at',
};

export const SORT_OPTIONS = {
  postedAt: 'posted_at',
};

export const ORDER_OPTIONS = {
  ascending: 1,
  descending: -1,
};

export const POLARITY_TYPES = {
  NEUTRAL: 3,
  NEGATIVE: 2,
  POSITIVE: 1,
  NO_POLARITY: 0,
};

export const PERFORMANCE_BY_TIME = {
  TOTAL: 'value',
  OPENED: 'opened_value',
  ANSWERED: 'answered_value',
  WAITING: 'waiting_value',
  CLOSED: 'closed_value',
  IGNORED: 'ignored_value',
  PERCENTAGE: 'percentage',
  PERCENTAGE_GLOBAL: 'percentage_global',
};
